/** 伙伴分享目标和接收方完整运价库契约，身份和金额保持字符串传输。 */
import type { PreviewRow, ShareBusinessType } from './types'
/** 分享目标类型，与后端代码一致。 */
export const SHARE_TARGET = { family: 'family', partner: 'partner' } as const
/** 接收库冻结伙伴价的来源，前端只展示服务端最终金额。 */
export const PARTNER_RATE_SOURCE = 'PARTNER_SHARE' as const
/** 当前选中的单个目标，伙伴身份由企业服务重新核验。 */
export interface ShareTargetChoice {
  /** 目标代码。 */
  target: (typeof SHARE_TARGET)[keyof typeof SHARE_TARGET]
  /** 伙伴企业主键，Family为空。 */
  enterpriseId?: string
  /** 仅用于展示的伙伴名称，不参与后端权限。 */
  name?: string
}
/** 可访问伙伴以及当前接收资格。 */
export interface PartnerOption {
  /** 同一实际接收企业的去重摘要，仅用于界面去重，不参与授权。 */
  recipientKey?: string | null
  /** 伙伴企业主键，不能代替租户身份。 */
  enterpriseId: string
  /** 企业名称。 */
  enterpriseName: string
  /** 当前客商是否同时具备客户和供应商角色。 */
  shareEligible: boolean
  /** 当前发送租户是否为该客商开通分享。 */
  shareEnabled: boolean
  /** 目标能解析正式租户且发送方已开通该客商分享。 */
  enabled: boolean
  /** 禁选原因国际化码。 */
  disabledReason: string | null
}
/** 伙伴分页和名称筛选。 */
export interface PartnerRequest {
  /** 页码从1开始。 */
  pageNum: number
  /** 每页最多50。 */
  pageSize: number
  /** 企业名称或编码，最多100字符。 */
  keyword: string
}
/** 有界MyBatis分页契约。 */
export interface PartnerPage<T = PartnerOption> {
  /** 当前页。 */
  current: number
  /** 每页数量。 */
  size: number
  /** 总条数。 */
  total: number
  /** 总页数。 */
  pages: number
  /** 当前页记录。 */
  records: T[]
}
/** 本租户运价库的伙伴来源查询。 */
export interface PartnerWarehouseRequest {
  /** 运价类型。 */
  businessType: ShareBusinessType
  /** 当前页码。 */
  pageNum: number
  /** 每页最多50。 */
  pageSize: number
  /** 本地或来源运价编码筛选。 */
  priceNo: string
}
/** 已直接保存到本租户库中的完整只读运价。 */
export interface PartnerWarehouseRecord {
  /** 接收方本地运价主键。 */
  id: string
  /** 接收方自己生成的运价编码。 */
  priceNo: string
  /** 分享时来源运价编码。 */
  sourcePriceNo: string | null
  /** 来源分享编码。 */
  shareCode: string
  /** 伙伴来源固定代码。 */
  source: 'PARTNER_SHARE'
  /** 1有效，2已撤回；过期由冻结有效期展示。 */
  state: number
  /** 已应用分享代数。 */
  generation: number
  /** 完整公开路线与全部最终价，禁止客户端二次算价。 */
  snapshot: PreviewRow
}
